export const INTEGRATION_SETTINGS = [
  {
    name: 'Chrome',
    label: 'Chrome extension',
    value: 'chrome',
    description: 'chrome',
    hash: '#chrome',
    type: 'Navigateur',
    logo: ['file', '/img/brand/chrome-logo.svg'],
    active: '',
    features: ['APP', 'PREFERENCES'],
    links: [
      {
        name: 'Extension Chrome',
        href: 'https://chrome.google.com/webstore/detail/mayday/eloemnahbeeiekllcfeombpkokhinkpn',
      },
    ],
  },
  {
    name: 'Zendesk',
    label: 'Zendesk',
    value: 'zendesk',
    description: 'zendesk',
    hash: '#zendesk',
    type: 'Ticketing',
    logo: ['file', '/img/brand/zendesk_200.png'],
    active: '',
    features: ['APP', 'AUTOMATION', 'IMPORT', 'PREFERENCES', 'ATTRIBUTES'],
    links: [
      {
        name: 'Documentation',
        href: 'https://documentation.mayday.fr/parametres/integrations/zendesk',
      },
    ],
  },
  {
    name: 'Intercom',
    label: 'Intercom',
    value: 'intercom',
    description: 'intercom',
    hash: '#intercom',
    type: 'Ticketing',
    logo: ['file', '/img/brand/intercom_200.png'],
    active: '',
    features: ['AUTOMATION', 'ATTRIBUTES'],
    links: [],
  },
  {
    name: 'Salesforce',
    label: 'Salesforce',
    value: 'salesforce',
    description: 'salesforce',
    hash: '#salesforce',
    type: 'Ticketing',
    logo: ['file', '/img/brand/salesforce-logo.png'],
    active: '',
    features: ['AUTOMATION', 'IMPORT', 'ATTRIBUTES'],
    links: [],
  },
  {
    name: 'Salesforce 2',
    label: 'Salesforce 2',
    value: 'salesforce_2',
    description: 'salesforce',
    hash: '#salesforce_2',
    type: 'Ticketing',
    logo: ['file', '/img/brand/salesforce-logo.png'],
    active: '',
    features: ['AUTOMATION', 'IMPORT', 'ATTRIBUTES'],
    links: [],
  },
  {
    name: 'Notion',
    label: 'Notion (Beta)',
    description: 'notion',
    value: 'notion',
    hash: '#notion',
    type: 'Base de connaissance',
    logo: ['file', '/img/brand/notion-logo.png'],
    active: '',
    features: ['IMPORT'],
    links: [],
  },
  {
    name: 'Slack',
    label: 'Slack (Beta)',
    description: 'slack',
    value: 'slack',
    hash: '#slack',
    type: 'Messagerie',
    logo: [
      'url',
      'https://cdn.bfldr.com/5H442O3W/at/pl546j-7le8zk-6gwiyo/Slack_Mark.svg?auto=webp&format=svg',
    ],
    active: '',
    features: ['APP', 'USERS'],
    links: [],
  },
];
